import { getReport, getExternalClientReport } from 'api/pdfReport';

export const downloadPdfReport = async (na, isExternalAccess, accessKey) => {
  try {
    const response = isExternalAccess
      ? await getExternalClientReport(na, accessKey)
      : await getReport(na);
    const blob = new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${na.name} Needs Assessment.pdf`;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    throw Error(error);
  }
};
